import ProductLineSelector from "components/shared/ProductLineSelector";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { ProductContext } from "./ProductForm";
import ProductListSelector from "./ProductListSelector";

const RelatedItemsView = () => {
  const { product, setProduct } = useContext(ProductContext);

  return (
    <div className="card">
      <h5>Related Items</h5>
      <div className="mt-4 space-y-4">
        <div>
          <label>Product Line</label>
          <div className="mt-2">
            <ProductLineSelector
              value={product.productLineId}
              onChange={(productLineId) =>
                setProduct((prev) => ({ ...prev, productLineId }))
              }
            />
            <div className="opacity-70 mt-1">
              Product lines shares some info like: hs code, age grading,
              warnings, pantone, lab test reports, printing method and materials
              with their products. This is useful only for salable products, for
              non-sale products, you can leave it blank.
            </div>
          </div>
        </div>

        <div>
          <label>Product List</label>
          <div className="mt-2">
            <ProductListSelector
              value={product.productListId}
              onChange={(productListId) =>
                setProduct((prev) => ({ ...prev, productListId }))
              }
            />
            <div className="opacity-70 mt-1">
              Product list shares the test reports.
            </div>
          </div>
        </div>

        {product.gtmProject && (
          <div>
            <label>GTM Project: </label>
            <Link
              className="pl-2"
              to={`/development/gtm-projects/${product.gtmProject.id}`}
              target="_blank"
            >
              {product.gtmProject.name} ({product.gtmProject.state})
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default RelatedItemsView;
